import $ from 'jquery';
import {Cookie} from "../helper/cookie";
import {reachGoal} from "js/utils/analytics";

export default class FormValidation {
    static oemSearchValidate() {
        $('body')
            .on('submit.oem', '#oem-search', function (e) {
                if (location.href.includes('autopart')) {
                    try {
                        if (window.country_code === 'ru') {
                            ym(49316365, 'reachGoal', 'search-block-button')
                        } else if (window.country_code === 'kz') {
                            ym(70024498, 'reachGoal', 'search-block-button-kz')
                        }
                    } catch (ex) {
                    }
                }

                let $input = $('input[name="article"]', e.currentTarget);
                if (!$input.length) {
                    return false;
                }
                let label = $input.closest('label');
                let blockError = label.find('.form-error');
                let val = $input.val().replace(/^\s+|\s+$/gm, '');
                let $mess = $('#oem-message');
                let message = '';
                const regex = RegExp('^[a-z0-9\\.\\s/\\-]*$', 'i');
                if (val.length === 0) {
                    message = 'Поле должно быть заполнено.';
                } else if (val.length < 4) {
                    message = 'Введите не менее 4 символов.';
                } else if (false === regex.test(val)) {
                    message = 'Присутствуют недопустимые символы.';
                } else if (val.length > 40) {
                    message = 'Превышена максимальная длина артиккула (40 символов).';
                }
                if (message.length) {
                    reachGoal('ru_text_part_number')
                    $input.addClass('is-invalid-input');
                    if ($mess.length) {
                        $mess.html(message).addClass('visible');
                    } else if (blockError.length) {
                        label.addClass('is-invalid-label');
                        // blockError.addClass('is-visible');
                        // blockError.text(message)
                    }
                    return false;
                } else {
                    $input.removeClass('is-invalid-input');
                    if (blockError.length) {
                        label.removeClass('is-invalid-label');
                        // blockError.removeClass('is-visible');
                    }
                }
                (new Cookie()).setCookie('search_request_name', 'article', {'max-age': 2592000});

                reachGoal('search_detail')
            })
            .on('keyup.oem', '#oem-search input[name="article"]', function () {
                $('#oem-message').removeClass('visible');
            })
        ;
    }
}
